


import React, { useEffect } from "react";
import { useState } from "react";
import './styles/cell.css';

function Cell({value,style}){

	// console.log("in cell")
	const [sty,setSty] = useState();
	const [color,setColor] = useState();
	const [myBlue,setMyBlue] = useState();

	useEffect(() => {
		
		if(style==='revealValue'){
			setInterval(() => {
				setMyBlue('blue')

				setInterval(() => {
					
					setSty('rotateY(180deg)');
					setColor('white')
				}, 1000);
			}, 50);
		}

		if(style ==='lightUp' ){
			setColor("white");
			setMyBlue('white')
		}

		if(style === 'reset'){
			console.log('we are resetting')
			setColor('darkgreen')
			setVal('2');
			setSty('rotateY(0)');

		}
		
	},[style]);

	const [val,setVal] = useState();
	useEffect(()=>{
		setTimeout(() => {
			setVal(value);
		}, 500);

	});		
		
	return (
		<div className='cardContainer'>

			<div className='card' style={{transform: sty}}>

				<div className='front' style={{backgroundColor: myBlue}}>
					<h1 id ="txt" className='text'>
					{/* {val} */}	
					</h1>
				</div>
				
				<div className='back' style={{backgroundColor: color}} >
					<h1 id ="txt" className='text'>
					{val}
					</h1>
				</div>

			</div>

		</div>
	);
	
}

export default Cell